import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { EidAuthStateAdapter } from '../providers/oidc/eid-auth-state.adapter';

/**
 * Guard for the /no-agency route.
 * If GET /users/me responds successfully the user already has a valid tenant,
 * so there is no reason to stay on /no-agency — redirect them to the employee
 * workspace instead. A 401/404 response means no tenant is assigned and the
 * user belongs on this page.
 */
export const noAgencyGuard: CanActivateFn = () => {
  const eidAuthStateAdapter = inject(EidAuthStateAdapter);
  const router = inject(Router);

  return eidAuthStateAdapter.checkUserAccess().pipe(
    map((hasAccess) => (hasAccess ? router.createUrlTree(['/employee']) : true)),
  );
};
